import React from 'react';
import { Table} from "antd";
const AntTableComponent = (props) => {
    return (
        <Table {...props.tableProps} />
    );
}
 
export default AntTableComponent;